<template>
  <div v-if="isInitial">
    <a id="isConfirmOrigin" @click="$emit('backToInput', inspection)"></a>
    <div class="content-wrapper">
      <div class="container">
        <article>
          <div class="step-bar-container">
            <ul>
              <li class="li-step">
                <span class="stepnum num01"></span>
                <span class="steptext">条件入力</span>
              </li>
              <li class="li-step">
                <span class="stepnum num02"></span>
                <span class="steptext">見積り確認</span>
              </li>
              <li class="li-step">
                <span class="stepnum num03"></span>
                <span class="steptext">連絡先入力</span>
              </li>
              <li class="li-step active">
                <span class="stepnum num04"></span>
                <span class="steptext">最終確認</span>
              </li>
            </ul>
          </div>
          <div class="section white-panel mb2p pb8">
            <p class="fs13 color-font2">車両情報やお客様の情報が正しく入力されていることを確認し、同意事項に全てチェックをした上で、店舗に申し込みをするボタンを押してください。</p>
          </div>

          <section class="section white-panel pt20 pb0">
            <h2 class="fs16 mb4">見積り金額(税込)</h2>
            <div class="flex">
              <p class="flex1 fs24 mb0">{{ $filters.addComma(price.total) }}円</p>
              <p class="fs14 font-weight-bold text-right mt8">
                <a v-on:click="toEstimateDetail()" class="color-green2 text-decoration-none icon-chevron-right">見積り詳細</a>
              </p>
            </div>
          </section>

          <section class="section white-panel pr0 pt12">
            <hr class="hr-solid-gray mb20">
            <h2 class="fs16 font-weight-bold">車両情報</h2>
            <table class="table w100p fs14">
              <tbody>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12 w30p">車検満了日</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ expiryOnWareki.gengo }}{{ $filters.checkFirstYear(expiryOnWareki.year) }}年{{ expiryOnWareki.month }}月{{ expiryOnWareki.date }}日</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">初度登録年月</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ firstRegistrationOnWareki.gengo }}{{ $filters.checkFirstYear(firstRegistrationOnWareki.year) }}年{{ firstRegistrationOnWareki.month }}月</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">自動車種別</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ carType.name }}</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">車名(メーカー)</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ Manufacturer.manufacturer_name }}</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">車両重量</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ $filters.addComma(car.weight) }}kg</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">走行距離</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{$filters.addComma(car.mileage * 1000) }}km</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section class="section white-panel pr0 pt12">
            <h2 class="fs16 font-weight-bold">日程調整に必要な情報</h2>
            <table class="table w100p fs14">
              <tbody>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12 w30p">電話番号</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p disable-auto-tel">{{ inspection.tel }}</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">連絡希望<br>時間帯</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p pre-wrap">{{ inspection.user_request }}</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">代車利用</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p" v-if="inspection.replacement_vehicle_requested === 'true'">必要</td>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p" v-if="inspection.replacement_vehicle_requested === 'false'">不要</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section class="section white-panel pr0 pt12 pb0 mb2p">
            <h2 class="fs16 font-weight-bold">車検実施店舗</h2>
            <table class="table w100p fs14">
              <tbody>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12 w30p">店舗名</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ ssInfo.ss_name }}</td>
                </tr>
                <tr>
                  <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">電話番号</th>
                  <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p disable-auto-tel">{{ ssInfo.tel }}</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section class="section white-panel pr0 pt24 pb0">
            <h2 class="fs16 font-weight-bold">確認・同意事項</h2>
            <table class="table w100p fs14">
              <tbody>
                <tr>
                  <td class="bdb-solid-gray1 pb12 pt12 pr2p td-checkbox-right">
                    <label class="pr44">
                      自動車税が納税済みで、証明書を持参できる
                      <input type="checkbox" name="" value="" class="checkbox-input1" v-model="agreement.matter1">
                      <span class="checkbox-area1"></span>
                    </label>
                  </td>
                </tr>
                <tr>
                  <td class="bdb-solid-gray1 pb12 pt12 pr2p td-checkbox-right">
                    <label class="pr44">
                      放置違反金（駐車違反の罰金等）がない
                      <input type="checkbox" name="" value="" class="checkbox-input1" v-model="agreement.matter2">
                      <span class="checkbox-area1"></span>
                    </label>
                  </td>
                </tr>
                <tr>
                  <td class="bdb-solid-gray1 pb12 pt12 pr2p td-checkbox-right">
                    <label class="pr44">
                      車両に違法改造・不正改造をしていない
                      <input type="checkbox" name="" value="" class="checkbox-input1" v-model="agreement.matter3">
                      <span class="checkbox-area1"></span>
                    </label>
                  </td>
                </tr>
                <tr>
                  <td class="bdb-solid-gray1 pb12 pt12 pr2p td-checkbox-right">
                    <a v-on:click="toAgreement()" class="color-green2">こちらの利用規約</a>
                    <label class="pr44">
                      に同意する
                      <input type="checkbox" name="" value="" class="checkbox-input1" v-model="agreement.matter4">
                      <span class="checkbox-area1"></span>
                    </label>
                  </td>
                </tr>
                <tr>
                  <td class="bdb-solid-gray1 pb12 pt12 pr2p td-checkbox-right">
                    <label class="pr44">
                      以下の注意事項について確認し了承した
                      <input type="checkbox" name="" value="" class="checkbox-input1" v-model="agreement.matter5">
                      <span class="checkbox-area1"></span>
                    </label>

                    <ul class="fs12 color-font2 line-height1_7 mt12 pr44 list-asterisk1">
                      <li>車検当日に、車検証、自賠責保険証、自動車納税証明書、を必ずお持ち頂く必要があります</li>
                      <li>メーカーやディーラーからのリコールのお知らせを受けていて未改修の場合、車検証を発行できないことがあります</li>
                      <li>ホイールにロックナット（盗難防止用ナット）をご利用している場合、キーアダプターを持参しないと車検を受けられません</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
          <div class="section transparent-panel">
            <p class="mb0 text-center error">{{form.agreementErrorMessage}}</p>
            <button v-bind:disabled="processing" @click="$emit('toCompleteCheck', agreement, form)" class="button fs16 mt8 mb16 pd16 radius200">店舗に申し込みをする</button>
          </div>
        </article>
      </div>
    </div>
  </div>
  <div v-else-if="isEstimateDetail">
    <a id="isEstimateDetail" v-on:click="toInitial()"></a>
    <EstimateDetailBefore v-bind:car="$route.params.car" v-bind:price="price" v-bind:expiryOnWareki="expiryOnWareki" v-bind:firstRegistrationOnWareki="firstRegistrationOnWareki" v-bind:Manufacturer="Manufacturer" v-bind:carType="carType"></EstimateDetailBefore>
  </div>
  <div v-else-if="isAgreement">
    <a id="isAgreement" v-on:click="toInitial()"></a>
    <Agreement></Agreement>
  </div>
</template>

<script>
import EstimateDetailBefore from '@/views/EstimateDetailBefore.vue'
import Agreement from '@/views/Agreement.vue'

const IS_INITIAL = 'IS_INITIAL'
const IS_ESTIMATE_DETAIL = 'IS_ESTIMATE_DETAIL'
const IS_AGREEMENT = 'IS_AGREEMENT'

export default {
  data: () => ({
    currentState: IS_INITIAL,
    agreement: {
      matter1: false,
      matter2: false,
      matter3: false,
      matter4: false,
      matter5: false
    },
    form: {
      agreementErrorMessage: ''
    }
  }),
  computed: {
    isInitial () {
      return this.currentState === IS_INITIAL
    },
    isEstimateDetail () {
      return this.currentState === IS_ESTIMATE_DETAIL
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    }
  },
  methods: {
    toInitial () {
      this.currentState = IS_INITIAL
      window.scrollTo(0, 0)
    },
    toEstimateDetail () {
      this.currentState = IS_ESTIMATE_DETAIL
      this.nativeEVENTSet('ShakenKakuninButton', 'MOVED_KEKKA_SHOSAI', 'TAP')
      window.scrollTo(0, 0)
    },
    toAgreement () {
      this.currentState = IS_AGREEMENT
      this.nativeEVENTSet('ShakenKakuninButton', 'MOVED_SHAKEN_RIYOUKIYAKU', 'TAP')
      window.scrollTo(0, 0)
    }
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    this.nativePVset('SHAKEN_KAKUNIN')
  },
  props: [
    'inspection',
    'car',
    'price',
    'expiryOnWareki',
    'firstRegistrationOnWareki',
    'carType',
    'Manufacturer',
    'ssInfo',
    'processing'
  ],
  components: {
    EstimateDetailBefore,
    Agreement
  }
}
</script>
